__turbopack_context__.v({
  "Bold": "ClaimScreenLegacy-module-scss-module__w054_W__Bold",
  "Description": "ClaimScreenLegacy-module-scss-module__w054_W__Description",
  "FormSection": "ClaimScreenLegacy-module-scss-module__w054_W__FormSection",
  "Fullstop": "ClaimScreenLegacy-module-scss-module__w054_W__Fullstop",
  "Label": "ClaimScreenLegacy-module-scss-module__w054_W__Label",
  "MerchantName": "ClaimScreenLegacy-module-scss-module__w054_W__MerchantName",
  "ThumbnailContainer": "ClaimScreenLegacy-module-scss-module__w054_W__ThumbnailContainer",
  "ThumbnailScale": "ClaimScreenLegacy-module-scss-module__w054_W__ThumbnailScale",
  "ThumbnailShadow": "ClaimScreenLegacy-module-scss-module__w054_W__ThumbnailShadow",
  "Title": "ClaimScreenLegacy-module-scss-module__w054_W__Title",
  "Wrapper": "ClaimScreenLegacy-module-scss-module__w054_W__Wrapper",
});
